import { useAdministrativeContext } from '../../../../../../../pages/administrativePanel/administrativePanelContext'
import { api } from '../../../../../../../services/api';
import { useCallback } from 'react';
import { toast } from 'react-toastify';

import { Container, RadioButton } from './style';


export function StatusFilter({ 
    statusSelected, 
    setStatusSelected,
    handleTermSearch,
    setSearchLoading,
    setPageSearch,
    setListSearchBusiness,
    setShowingFilteredBusiness
}) {
    const { syncInformations } = useAdministrativeContext()


    const fetchingSyncBusiness = useCallback(async (status) =>  {
        if(status === 0 && handleTermSearch === ''){
            setListSearchBusiness([])
            setShowingFilteredBusiness(false)
            setStatusSelected(0)
            return
        }

        setSearchLoading(true)
        try{
            const response = await api.get(`/getBusinessAdm/?quantity=20&search=${handleTermSearch}&sync=${status}`, {
                headers: {
                  token: localStorage.getItem('@Inoveclube:token')
                }
            })
           
            const { business, next_page } = response.data
            

            setStatusSelected(status)
            setListSearchBusiness(business)
            setShowingFilteredBusiness(true)
            setPageSearch(next_page ? 40 : null)
            setSearchLoading(false)
        }catch{
            setSearchLoading(false)
            toast.error('Tente novamente')
        }
      
    }, [handleTermSearch, setListSearchBusiness, setPageSearch, setSearchLoading, setStatusSelected, setShowingFilteredBusiness])



    return(
        <Container>

            <RadioButton
                active={statusSelected === 0}
                onClick={() => fetchingSyncBusiness(0)}
            >
                <span>{syncInformations.all}</span>
                <p>Todas</p>
            </RadioButton>

            <RadioButton
                active={statusSelected === 1}
                onClick={() => fetchingSyncBusiness(1)}
            >
                <span>{syncInformations.recents}</span>
                <p>Recentes</p>
            </RadioButton>

            <RadioButton
                active={statusSelected === 2}
                onClick={() => fetchingSyncBusiness(2)}
            >
                <span>{syncInformations.old}</span>
                <p>Antigas</p>
            </RadioButton>

        </Container>
    )
}
